var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('div',{staticClass:"ad-vip-audio"},[_c('k-block',{attrs:{"name":"ad_vip_audio"}}),_c('a',{staticClass:"ad-vip-audio__link v-eid-adVipAudio",attrs:{"href":_vm.href}},[_c('span',[_vm._v("立即查看")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }